import { Site } from '../../site-detail/models/Site';
import { getSiteGatewayIds } from '../../site-detail/utils/gateway';
import { isBeeconGateway } from '../../site-gateway/utils/gateway.utils';

// A site created without any box: it is not yet usable for remote diagnostic.
export function hasNoBox(site: Site): boolean {
    return getSiteGatewayIds(site).length === 0;
}

// A site whose only boxes are Beecon ones, which are not compatible with remote diagnostic yet.
// A site mixing a Beecon box with a compatible box stays active.
export function hasBeeconBoxesOnly(site: Site): boolean {
    const gatewayIds = getSiteGatewayIds(site);
    return gatewayIds.length > 0 && gatewayIds.every(isBeeconGateway);
}
